import styled from 'styled-components';

export const ProcessButtonContainer = styled.div`
  width: 50%;
  margin: auto;
`;
